import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-[#0a0f1c]/95 backdrop-blur-lg shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/03bed3920353e1c914a48979e0760637/58a2f24010e53db81b2c2c87fe73444e.png" 
              alt="Master Jae Production Logo" 
              className="h-12 w-12 object-contain"
            />
            <div>
              <div className="text-white font-bold text-xl tracking-wider">MASTER JAE</div>
              <div className="text-[#00d9ff] text-xs tracking-widest">PRODUCTION</div>
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer">About</button>
            <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer">Services</button>
            <button onClick={() => scrollToSection('portfolio')} className="text-gray-300 hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer">Portfolio</button>
            <button onClick={() => scrollToSection('pricing')} className="text-gray-300 hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer">Pricing</button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer">Contact</button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-[#ff6b35] text-white px-6 py-2 rounded-full hover:bg-[#ff8555] transition-all duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Book Session
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
